export default "__VITE_ASSET__a11da21b__"